import { useState } from "react";
import { useSelector } from "react-redux";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { RootState } from "../../../state/store";

type RepairsFaultsCellProps = {
  stoppage: StoppageDto
  handleRepairFaultsChange: (stoppage: StoppageDto) => Promise<void>
}

const RepairsFaultsCell: React.FC<RepairsFaultsCellProps> = ({ stoppage, handleRepairFaultsChange }) => {
  const isShiftLocked = useSelector((state: RootState) => state.shift.isLocked);
  const [textState, setTextState] = useState<string>(stoppage.repairsFaults || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        value={textState}
        disabled={isShiftLocked}
        placeholder="No Repairs/Faults"
        onChange={(e) => setTextState(e.target.value)}
        onSubmit={async () => {
          await handleRepairFaultsChange(new StoppageDto({ ...stoppage, repairsFaults: textState }));
        }}
      />
    </div>
  )
}

export default RepairsFaultsCell